export class CustomOptions {
  constructor(pUID, pName) {
    this.partOptions = [];
    this.productUID = pUID;
    this.productName = pName;
    this.fullConfig = {};
  }

  updatePartOption(partUID, category, value) {
    let option = this.partOptions.find((element) => element.uid == partUID);
    option.typeCategoryID = category;
    option.typeUID = value;
  }

  createPartOption(keyUID, keyType) {
    let option = {
      uid: keyUID,
      type: keyType,
      typeCategoryID: null,
      typeUID: null,
    };
    this.partOptions.push(option);
  }

  getPartOptions() {
    return this.partOptions;
  }

  getConfig() {
    this.fullConfig = {
      productUID: this.productUID,
      productName: this.productName,
      productPartsOptions: this.partOptions,
    };
    return this.fullConfig;
  }
}
